export default "__VITE_ASSET__DyKkaDIO__"